import React, { useRef } from "react";
export default function CategoryScroll({ categories, selectedCategory, onSelectCategory }) {
    const scrollRef = useRef();
    const scroll = (direction) => {
        const container = scrollRef.current;
        if (direction === "left") container.scrollBy({ left: -150, behavior: "smooth" });
        else container.scrollBy({ left: 150, behavior: "smooth" });
    };
    return (
        <div className="category-scroll-wrapper">
            <button className="scroll-btn left" onClick={() => scroll("left")}>‹</button>
            <div className="category-scroll" ref={scrollRef}>
                {categories.map((cat, index) => (
                    <div
                        key={index}
                        className={`category-item ${selectedCategory === cat.name ? "active" : ""}`}
                        onClick={() => onSelectCategory(cat.name)}>
                        <img src={cat.image} alt={cat.name} />
                        <span>{cat.name}</span>
                    </div>
                ))}
            </div>
            <button className="scroll-btn right" onClick={() => scroll("right")}>›</button>
        </div>
    );
}